/* ============================================================
   Styleout Watches — light theme interactions
   Vanilla JS, event-delegated. Drives:
   - mobile drawer menu
   - hero slideshow (crossfade autoplay)
   - booking / enquiry modal (viewing + info variants)
   - product image zoom
   - sticky enquiry bar
   ============================================================ */
(function () {
  'use strict';

  var MODAL_CONFIG = {
    viewing: {
      eyebrow: 'Private Viewing',
      title: 'Book your visit',
      cta: 'Confirm request',
      subject: 'Private viewing request',
      showDate: true,
      showQuestion: false
    },
    info: {
      eyebrow: 'Enquiry',
      title: 'Request information',
      cta: 'Send enquiry',
      subject: 'Information request',
      showDate: false,
      showQuestion: true
    }
  };

  /* ---------- Modal ---------- */
  function getModal() { return document.querySelector('[data-so-modal]'); }

  function setEl(modal, name, value) {
    var el = modal.querySelector('[data-so-el="' + name + '"]');
    if (el && value != null) el.textContent = value;
  }

  function openModal(type, ref) {
    var modal = getModal();
    if (!modal) return;
    var cfg = MODAL_CONFIG[type] || MODAL_CONFIG.viewing;

    setEl(modal, 'eyebrow', cfg.eyebrow);
    setEl(modal, 'title', cfg.title);
    setEl(modal, 'cta', cfg.cta);

    // Reference line (only when a product reference is supplied)
    var refWrap = modal.querySelector('[data-so-el="refline"]');
    if (refWrap) {
      if (ref) {
        refWrap.classList.remove('so-modal__hide');
        setEl(modal, 'ref', ref);
      } else {
        refWrap.classList.add('so-modal__hide');
      }
    }

    // Toggle date input vs question textarea
    var dateField = modal.querySelector('[data-so-el="date"]');
    var qField = modal.querySelector('[data-so-el="question"]');
    if (dateField) {
      dateField.classList.toggle('so-modal__hide', !cfg.showDate);
      dateField.disabled = !cfg.showDate;
    }
    if (qField) {
      qField.classList.toggle('so-modal__hide', !cfg.showQuestion);
      qField.disabled = !cfg.showQuestion;
    }

    // Hidden subject field for the contact form
    var subject = modal.querySelector('[data-so-el="subject"]');
    if (subject) subject.value = (cfg.subject || cfg.title) + (ref ? ' — ' + ref : '');

    modal.setAttribute('data-so-state', 'idle');
    modal.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    updateSticky();
  }

  function closeModal() {
    var modal = getModal();
    if (!modal) return;
    modal.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    updateSticky();
  }

  /* ---------- Sticky enquiry bar ---------- */
  /* Shown once the product info has scrolled past. Uses an IntersectionObserver
     on an anchor so it works regardless of which element actually scrolls
     (Horizon scrolls a container, so window.scrollY can't be relied on). */
  var stickyPast = false;

  function getSticky() { return document.querySelector('[data-so-sticky]'); }

  function updateSticky() {
    var bar = getSticky();
    if (!bar) return;
    var modalOpen = getModal() && getModal().classList.contains('is-open');
    bar.classList.toggle('is-visible', stickyPast && !modalOpen);
  }

  function initSticky() {
    if (!getSticky()) return;
    var anchor = document.querySelector('[data-so-sticky-anchor]');
    if (anchor && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        stickyPast = !e.isIntersecting && e.boundingClientRect.top < 0;
        updateSticky();
      }, { threshold: 0 });
      io.observe(anchor);
    } else {
      // Fallback: window scroll
      window.addEventListener('scroll', function () {
        stickyPast = (window.scrollY || document.documentElement.scrollTop) > 700;
        updateSticky();
      }, { passive: true });
    }
  }

  /* ---------- Hero slideshow ---------- */
  function initHero(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-so-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-so-dot]'));
    if (slides.length < 2) return;

    var interval = parseInt(root.getAttribute('data-so-interval'), 10) || 6500;
    var current = 0;
    var timer;

    function show(i) {
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === current); });
      dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === current); });
    }
    function start() { timer = setInterval(function () { show(current + 1); }, interval); }
    function reset() { clearInterval(timer); start(); }

    root.addEventListener('click', function (e) {
      var nav = e.target.closest('[data-so-hero]');
      if (nav) {
        var dir = nav.getAttribute('data-so-hero');
        show(dir === 'prev' ? current - 1 : current + 1);
        reset();
        return;
      }
      var dot = e.target.closest('[data-so-dot]');
      if (dot) {
        show(dots.indexOf(dot));
        reset();
      }
    });

    show(0);
    start();
  }

  /* ---------- Product zoom ---------- */
  function initZoom(root) {
    var img = root.querySelector('[data-so-zoom-img]');
    var hint = root.querySelector('[data-so-zoom-hint]');
    if (!img) return;
    var scale = parseFloat(root.getAttribute('data-so-zoom-scale')) || 2.1;

    root.addEventListener('mouseenter', function () {
      img.style.transform = 'scale(' + scale + ')';
      if (hint) hint.textContent = 'Move to inspect';
    });
    root.addEventListener('mousemove', function (e) {
      var r = root.getBoundingClientRect();
      var x = Math.round(((e.clientX - r.left) / r.width) * 100);
      var y = Math.round(((e.clientY - r.top) / r.height) * 100);
      img.style.transformOrigin = x + '% ' + y + '%';
    });
    root.addEventListener('mouseleave', function () {
      img.style.transform = 'scale(1)';
      img.style.transformOrigin = '50% 50%';
      if (hint) hint.textContent = 'Hover to zoom';
    });
  }

  /* ---------- Global delegated clicks ---------- */
  document.addEventListener('click', function (e) {
    // Drawer
    if (e.target.closest('[data-so-drawer-open]')) {
      var d = document.querySelector('[data-so-drawer]');
      if (d) d.classList.add('is-open');
      return;
    }
    if (e.target.closest('[data-so-drawer-close]') ||
        (e.target.matches('[data-so-drawer]'))) {
      var dd = document.querySelector('[data-so-drawer]');
      if (dd) dd.classList.remove('is-open');
      // don't return — a drawer link may also be a modal opener
    }

    // Modal open
    var opener = e.target.closest('[data-so-modal-open]');
    if (opener) {
      e.preventDefault();
      openModal(opener.getAttribute('data-so-modal-open'), opener.getAttribute('data-so-ref') || '');
      return;
    }

    // Modal close (× button or overlay backdrop)
    if (e.target.closest('[data-so-modal-close]') || e.target.matches('[data-so-modal]')) {
      closeModal();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeModal();
      var d = document.querySelector('[data-so-drawer]');
      if (d) d.classList.remove('is-open');
    }
  });


  // Product gallery: click a thumbnail → swap the main image
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-so-thumb]');
    if (!thumb) return;
    var main = document.querySelector('[data-so-main-img]');
    if (main) { main.src = thumb.getAttribute('data-so-thumb'); main.removeAttribute('srcset'); }
    var scope = thumb.closest('.so-pdp') || document;
    var actives = scope.querySelectorAll('.so-thumb.is-active');
    for (var i = 0; i < actives.length; i++) actives[i].classList.remove('is-active');
    thumb.classList.add('is-active');
  });

  // Featured collection slider arrows
  document.addEventListener('click', function (e) {
    var nav = e.target.closest('[data-so-fc]');
    if (!nav) return;
    var scope = nav.closest('section') || document;
    var track = scope.querySelector('.so-fc-track');
    if (!track) return;
    var slide = track.querySelector('.so-fc-slide');
    var oneCard = slide ? slide.getBoundingClientRect().width + 22 : 320;
    // Scroll roughly one visible page of cards per click (min one card)
    var amount = Math.max(oneCard, Math.round(track.clientWidth * 0.85));
    track.scrollBy({ left: nav.getAttribute('data-so-fc') === 'prev' ? -amount : amount, behavior: 'smooth' });
  });

  // Collection filters + sort: any marked input submits its GET form
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-so-autosubmit]');
    if (!input) return;
    var form = input.closest('[data-so-filter-form]');
    if (form) form.submit();
  });

  /* ---------- Header height → CSS var (for sticky sidebar offset) ---------- */
  function measureHeader() {
    var hdr = document.querySelector('header.so');
    if (hdr) {
      document.documentElement.style.setProperty('--so-header-h', hdr.offsetHeight + 'px');
    }
  }

  /* ---------- Boot ---------- */
  function initWaFloat() {
    var fab = document.querySelector('[data-so-wa-float]');
    if (!fab) return;
    var hero = document.querySelector('[data-so-hero-root]');
    var shown = false;
    function reveal() {
      if (shown) return;
      shown = true;
      fab.classList.add('is-in');
      // capture:true so scroll from Horizon's inner scroll container is caught too
      window.removeEventListener('scroll', check, true);
    }
    // Only show once the hero has scrolled mostly out of view. No timer, so the
    // button never pops in while the visitor is still on the hero at load.
    function check() {
      if (shown) return;
      if (!hero) { reveal(); return; }           // non-home pages: show right away
      var r = hero.getBoundingClientRect();
      if (r.bottom < window.innerHeight * 0.55) reveal();
    }
    window.addEventListener('scroll', check, { capture: true, passive: true });
    check();
  }

  // Announcement bar: fade one message to the next. Respects reduced-motion.
  function initAnnounce() {
    var bar = document.querySelector('[data-so-announce]');
    if (!bar) return;
    var items = bar.querySelectorAll('.so-announce__item');
    if (items.length < 2) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var interval = parseInt(bar.getAttribute('data-so-interval'), 10) || 4000;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, interval);
  }

  // YouTube facade: swap the poster for the real iframe only on click, so the
  // heavy YouTube player never loads on page load (keeps LCP/CWV clean).
  function initVideoFacade() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-so-video]');
      if (!btn || btn.classList.contains('is-playing')) return;
      var id = btn.getAttribute('data-so-video');
      if (!id) return;
      var ifr = document.createElement('iframe');
      ifr.src = 'https://www.youtube-nocookie.com/embed/' + id +
                '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
      ifr.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
      ifr.setAttribute('allowfullscreen', '');
      ifr.setAttribute('title', 'Video');
      btn.innerHTML = '';
      btn.appendChild(ifr);
      btn.classList.add('is-playing');
      btn.style.cursor = 'default';
    });
  }

  function boot() {
    var hero = document.querySelector('[data-so-hero-root]');
    if (hero) initHero(hero);

    var zoom = document.querySelector('[data-so-zoom]');
    if (zoom) initZoom(zoom);

    measureHeader();
    window.addEventListener('resize', measureHeader, { passive: true });

    initSticky();
    initWaFloat();
    initAnnounce();
    initVideoFacade();

    // If the modal contact form was just submitted, re-open the modal in its
    // "thank you" state (Shopify reloads the page after a contact post).
    // Skip on pages that show their own inline confirmation (e.g. the contact
    // page) — Shopify flags posted_successfully on every contact form on the
    // page, which would otherwise pop this modal on top of the inline success.
    var modal = getModal();
    if (modal && modal.getAttribute('data-so-posted') === 'true' && !document.querySelector('.so-contact')) {
      modal.setAttribute('data-so-state', 'sent');
      modal.classList.add('is-open');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
